import { Controller } from "@hotwired/stimulus"
import { handleFormSubmission } from "../utils/form.js"

export default class extends Controller {
  submit (event) {
    handleFormSubmission(event.currentTarget.closest("form"), [{ name: "continue", value: event.params.continue }])
  }
}
